import "./LaserEngravingPhenolic.module.css";
import Header from "@/reusable_sections/Header";
import ServiceHeroPhenolic from "./sections/ServiceHeroPhenolic";
import TechnicalOverview from "./sections/TechnicalOverview";
import SpecificationsOptions from "./sections/SpecificationsOptions";
import Capabilities from "./sections/Capabilities";
import HowToOrder from "./sections/HowToOrder";
import ComplianceStandards from "./sections/ComplianceStandards";
import Faq from "./sections/Faq";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function LaserEngravingPhenolicPage() {
  return <div>
      <Header />
      <ServiceHeroPhenolic />
      <TechnicalOverview />
      <SpecificationsOptions />
      <Capabilities />
      <HowToOrder />
      <ComplianceStandards />
      <Faq />
      <CallToAction />
      <Footer />
    </div>;
}